module.exports = __webpack_public_path__ + "static/media/paint6.071bbe57.jpg";